import { ViewMode } from '@common/models/view-mode';
import { PopupSettings } from '@progress/kendo-angular-dropdowns';
import gitVersionInfo from '../../git-version-info.json';
import packageJson from '../../package.json';

const serverUrl = `${window.origin}/be`;
const apiUrl = `${serverUrl}/api`;
const plannerUrl = `${window.location.protocol}//${window.location.hostname}:5000/optimize`;

export const environment = {
    production: false,
    name: 'base',
    serverUrl,
    apiUrl,
    plannerUrl,
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    title: 'AI Berthing',
    version: packageJson.version,
    gitVersionInfo: gitVersionInfo,
    defaultLanguage: 'en',
    weatherStations: {
        weatherStationsApi:
            'https://ai-berthing.portline.eu/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=parameters',
        serviceUrlParameters: '/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=parameters',
        serviceUrlOperations: '/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=operations',
        serviceUrlPlaces: '/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=places',
        serviceUrlWithParams:
            'https://ai-berthing.portline.eu/export/73c825c43977c096e18dacc1be9b846e83473262/data?place_id={placeId}&interval_code=U&start_time={startTime}',
        directUrlWithParams:
            'https://ai-berthing.portline.eu/export/73c825c43977c096e18dacc1be9b846e83473262/data?place_id={placeId}&interval_code=U&start_time={startTime}'
    },
    settings: {
        header: {
            logo: '/assets/img/logo.ico',
            welcomeMessage: 'Welcome to',
            themeColor: 'dark',
            environmentColor: '#fff'
        },
        appControl: {
            multi: false,
            time: true,
            codelist: {
                take: 100
            },
            fileDownloadUrl: `${apiUrl}/query/DownloadAttachment`,
            fileRestrictions: {
                allowedExtensions: [
                    '.jpg',
                    '.jpeg',
                    '.png',
                    '.bmp',
                    '.tif',
                    '.doc',
                    '.docx',
                    '.xls',
                    '.xlsx',
                    '.txt',
                    '.pdf',
                    '.xslt'
                ],
                allowedImageExtensions: ['.jpg', '.jpeg', '.png', '.bmp', '.tif']
            },
            dropdown: {
                popupSettings: undefined as PopupSettings
            },
            dateFormat: 'dd.MM.yyyy',
            timeFormat: 'HH:mm'
        },
        grid: {
            pageable: { buttonCount: 4, info: true, type: 'numeric', pageSizes: [10, 20, 50] },
            pageSize: 50,
            sortable: false,
            sort: [
                {
                    field: 'id',
                    dir: 'asc'
                }
            ],
            filterable: true,
            reorderable: true,
            resizable: true,
            compressedGridValue: '4px',
            autoFitColumns: true
        },
        view: {
            defaultViewMode: ViewMode.view,
            save: {
                redirectToViewMode: ViewMode.view
            }
        },
        list: {
            persistFilter: true,
            rememberFilterState: true
        },
        roundingSettings: {
            price: 3,
            quantity: 3,
            amount: 2,
            taxAmount: 2,
            discountPercentage: 2
        },
        rememberState: {
            actionBar: true,
            darkMode: true,
            filters: true,
            filter: true,
            language: true,
            sidebarPinned: true,
            toggleableFilter: true,
            gridSettings: true
        },
        login: {
            languageFlag: false,
            forgotPassword: true,
            userRegistration: true,
            termsAndConditions: true,
            alternatives: {
                certificate: true,
                google: true,
                facebook: true,
                apple: true
            }
        }
    }
};
